import React from 'react';
import { WrenchIcon } from 'lucide-react';
import { site } from '../data/site';
type LogoProps = {
  inverted?: boolean;
};
export function Logo({
  inverted = false
}: LogoProps) {
  return <a href="#top" className="flex items-center gap-3" aria-label={`${site.name} home`} data-id="element-208" data-mp="3q9upghumn1py">
      <span className={`grid h-11 w-11 place-items-center rounded-full border-2 ${inverted ? 'border-white bg-ink text-white' : 'border-ink bg-white text-ink'}`} data-id="element-209" data-mp="3v8eggwo2v3p6">
        <WrenchIcon className="h-5 w-5" strokeWidth={2.5} aria-hidden="true" data-id="element-210" data-mp="rrp7l410vhwc" />
      </span>
      <span className="leading-none" data-id="element-211" data-mp="ds6d3e14w52i">
        <span className={`block whitespace-nowrap font-display text-2xl font-extrabold uppercase tracking-tight ${inverted ? 'text-white' : 'text-ink'}`} data-id="element-212" data-mp="dr4os7v3xm2u">
          Home Repair <span className={inverted ? 'text-ink' : 'text-brand'} data-id="element-213" data-mp="2yhlzzxx8f9mv">MD</span>
        </span>
        <span className={`mt-1 block text-[11px] font-semibold ${inverted ? 'text-white/85' : 'text-ink-muted'}`} data-id="element-214" data-mp="32l1rygycwlt8">
          {site.license}
        </span>
      </span>
    </a>;
}